import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import { Collection, ExecuteOperationOnPipe, Model, useValue } from '@morningtrain/react-resources'
import moment from 'moment'
import { Translation, Translator } from '@morningtrain/react-translations'
import * as UI from 'ui'
import { ButtonWrap, HighlightCard, HighlightCardsWrapper } from 'ui'
import {
  MountSmartviewOnClick,
  MountSmartviewOnSelection
} from '@morningtrain/react-smartviews'
import { EditHistoricShiftsSmartview } from 'widgets/smartviews/EditHistoricShiftsSmartview'
import Button from '../../ui/buttons/Button'
import EntriesHighlight from 'pages/app/shifts/partials/EntriesHighlight'
import { Table } from 'widgets/crud'
import HistoricShiftRow from 'pages/app/shifts/HistoricShiftRow'
import * as Filters from 'support/filters'
import { SelectedDepartmentFilter } from 'support/filters'
import { StaticFilter } from '@morningtrain/react-filters'
import * as Displays from 'support/displays'

export default function ManageShiftEntriesSmartview ({ location = null, type = null }) {
  const timestamp = useValue('timestamp')
  const date = moment.unix(timestamp)
  const dateAsString = date.format('YYYY-MM-DD')

  const smartviewSize = '4xl'

  return (
    <Smartview size={smartviewSize}>

      <Model resourceName='shifts.historic' operationName='index_with_summary'>

        <Translator namespace='historicshifts'>
          <UI.CardHeader>
            <UI.WithSubtitle subtitle={<Displays.Date dateFormat='ddd D. MMM YYYY' defaultValue={date} />}>
              <UI.Text weight='medium' size='lg'>
                <Translation name='title' />
                {location && (
                  <UI.Text lowercase>
                    <span> - </span>
                    <Displays.Enum enum='employment_type_category' defaultValue={location} />
                  </UI.Text>
                )}
              </UI.Text>
            </UI.WithSubtitle>
            <ButtonWrap>
              <MountSmartviewOnClick
                keepTreeOnPush
                smartview={(
                  <EditHistoricShiftsSmartview
                    size={smartviewSize}
                    date={dateAsString}
                    type={type}
                    location={location}
                    create
                    refreshPipes={(
                      <ExecuteOperationOnPipe namespace='api' resourceName='dashboard' operationName='wage_ratio' />
                    )}
                  />
                )}
                replace={false}
              >
                <Button>
                  <Translation name='create' />
                </Button>
              </MountSmartviewOnClick>
            </ButtonWrap>
          </UI.CardHeader>
          <HighlightCardsWrapper className='w-2/5'>
            <HighlightCard
              backgroundColor='bg-background'
              title={<Translation name='highlight_cards.total_hours' />}
              content={<Displays.Number name='totalDuration' />}
            />
            <HighlightCard
              backgroundColor='bg-background'
              title={<Translation name='highlight_cards.total_shifts' />}
              content={<Displays.Integer name='totalShifts' />}
            />
          </HighlightCardsWrapper>
          <Collection resourceName='shifts.historic' useParentConstrainable>
            <SelectedDepartmentFilter />
            {location && <StaticFilter name='location' value={location} />}
            {type && <StaticFilter name='type' value={type} />}
            {date && <StaticFilter name='date' value={date.format('YYYY-MM-DD')} />}
            <MountSmartviewOnSelection
              smartview={(
                <EditHistoricShiftsSmartview
                  size={smartviewSize}
                  date={dateAsString}
                  type={type}
                  location={location}
                  refreshPipes={(
                    <ExecuteOperationOnPipe namespace='api' resourceName='dashboard' operationName='wage_ratio' />
                )}
                />
            )}
              replace={false}
              keepTreeOnPush
            />
            <Table className='mt-6'>
              <HistoricShiftRow />
            </Table>
          </Collection>
          <Filters.PaginationFilter />
        </Translator>
      </Model>

    </Smartview>
  )
}
